export default __webpack_public_path__ + "static/media/gallery_02.05e9c4e1.jpg";